import React, { useState, useEffect,useRef } from 'react';
import OtpImage from '../../assets/images/mobile-otp.png';

const OtpModal = ({setOtpModel,otpFieldValue, setOtpFieldValue,onSubmit, sendOtpHandler,otpLoading,setOtpLoading }) => {
    const [resendTimer, setResendTimer] = useState(30); 
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const fieldRef = useRef();

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
            return () => clearInterval(timer); // Cleanup the interval
        } else {
            setIsResendEnabled(true);
        }
    }, [resendTimer]);

    const handleResendClick = () => {
        setOtpLoading(false)
        setResendTimer(30); // Reset the timer
        onSubmit()
        setOtpFieldValue({value:''})
        setIsResendEnabled(false); // Disable resend until countdown ends
    };

    const sendOtpHandlerFunc = () => {
        if(!otpFieldValue.value){
            fieldRef.current.style.borderColor = 'red'; 
            fieldRef.current.focus();
        }else{
            sendOtpHandler()
        }
    }

    const otpModelHandler = () => {
            setOtpModel(false)
            setOtpFieldValue({value:''})
            setOtpLoading(false)
        
    }

    return (

            <div className="otp_modal">
                <div className="modal_overlay"></div>
                <div className="modal-box modal-dialog-centered">
                    <div className="otp_modal_wrapper">
                        <img src={OtpImage} alt="Enter otp" className="img-fluid" />
                        <h3>VERIFICATION PASSKEY</h3>
                        <p>
                            ONE TIME PASSKEY SENT TO YOUR<br />REGISTERED WHATSAPP MOBILE NUMBER
                        </p>
                        <input
                            type="text"
                            value={otpFieldValue.value}
                            placeholder="ENTER PASSKEY"
                            required
                            ref={fieldRef}
                            onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/\D/g, ''); // Allow only numeric values
                                setOtpFieldValue({ ...otpFieldValue, value, error: '' });
                            }}
                        />
                        <p>
                            DIDN'T RECEIVE THE PASSKEY?{' '}
                            <span
                                className={`link ${isResendEnabled ? '' : 'disabled'}`}
                                onClick={isResendEnabled ? handleResendClick : null}
                                style={{ cursor: isResendEnabled ? 'pointer' : 'not-allowed' }}
                            >
                                RESEND PASSKEY {resendTimer > 0 && `(${resendTimer}s)`}
                            </span>
                        </p>
                        <p>OR</p>
                        <p onClick={otpModelHandler}>
                            <span>WANT TO CHANGE MOBILE NUMBER?</span>
                        </p>

                        {
                            otpLoading ? <button className="btn btn-primary w-100" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                            VERIFYING</button> :<button
                            className="btn btn-primary mt-2 w-100"
                            onClick={sendOtpHandlerFunc}
                            type="button"
                        >
                            VERIFY
                        </button>
                        }
                        
                    </div>
                </div>
            </div>
        
    );
};

export default OtpModal;
